// Material Kit 2 React pages
import Profile from "pages/Profile";

export default function ProfilePage() {
  return <Profile />;
}
